import type { SVGProps } from 'react';

const SvgFavoriteAssets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m10.45 10.11-2-1a1.02 1.02 0 0 0-1.05.09L5 11V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.35-3-3-3H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-.5l3.11-2.33 1.45.72c.49.25 1.09.05 1.34-.45a.993.993 0 0 0-.45-1.34z"
    />
    <path
      fill="currentcolor"
      d="M11.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m9.41 3.44c-.9-.63-2.08-.78-3.15-.39q-.6.21-1.05.6-.465-.39-1.05-.6c-1.07-.38-2.25-.24-3.15.39-.85.6-1.39 1.52-1.48 2.54s.28 2.02 1 2.75L15.3 21c.39.39.9.58 1.41.58s1.02-.2 1.41-.58l3.27-3.27c.72-.72 1.09-1.73 1-2.75a3.46 3.46 0 0 0-1.48-2.54"
    />
  </svg>
);
export default SvgFavoriteAssets;
